export const updateState = (referentiel, oldState, newState) => {
  return {
    ...oldState,
    [referentiel]: {
      ...oldState[referentiel],
      ...newState,
    },
  };
};

export const formatDataForSearch = (
  filters,
  paginationState,
  sortState = { direction: "DESC", sortField: "id" }
) => {
  return {
    criteria: filters,
    ...paginationState,
    ...sortState,
  };
};
export const printInitialState = {
  content: {},
  type: null,
  fileName: null,
  isLoading: false,
  isSuccessed: false,
  hasError: false,
  error: null,
};

export const situationInitialState = {
  content: {},
  isLoading: false,
  totalElements: 0,
  isSuccessed: false,
  hasError: false,
  error: null,
};
export const arrayContentElementInitialState = {
  content: [],
  isLoading: false,
  isSuccessed: false,
  hasError: false,
  error: "",
};

export const paginatedArrayContentElementInitialState = {
  content: [],
  totalElements: 0,
  isLoading: false,
  isSuccessed: false,
  hasError: false,
  error: "",
};

export const objectContentElementInitialState = {
  content: {},
  isLoading: false,
  isSuccessed: false,
  hasError: false,
  error: "",
};

export const noContentElementInitialState = {
  isLoading: false,
  isSuccessed: false,
  hasError: false,
  error: "",
};

  export const formatPrices = (dirhams) => {
  if (!dirhams) {
    return "0.0";
  }
  return dirhams.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
